import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownTimerProps {
  variant?: 'small' | 'large';
}
export function CountdownTimer({
  variant = 'small'
}: CountdownTimerProps) {
  const {
    minutes,
    seconds
  } = useCountdown(890);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  if (variant === 'small') {
    return <span className="font-mono font-bold tracking-wider" data-id="element-13">
        {formatNumber(minutes)}:{formatNumber(seconds)}
      </span>;
  }
  return <div className="flex justify-center items-center gap-1.5" data-id="element-14">
      <div className="bg-[#586880] text-white text-lg font-bold font-mono py-1 px-2.5 rounded-md min-w-[40px] text-center" data-id="element-15">
        {formatNumber(minutes)}
      </div>
      <span className="text-[#586880] text-lg font-bold" data-id="element-16">:</span>
      <div className="bg-[#586880] text-white text-lg font-bold font-mono py-1 px-2.5 rounded-md min-w-[40px] text-center" data-id="element-17">
        {formatNumber(seconds)}
      </div>
    </div>;
}